/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SecurityProgrammes_manager = {
    readonly company: {
        readonly securityProgrammes: {
            readonly edges: ReadonlyArray<{
                readonly uuid: string;
                readonly name: string;
                readonly createdAt: string;
                readonly downloadURL: string;
            }>;
            readonly pageInfo: {
                readonly total: number;
                readonly offset: number;
                readonly limit: number;
                readonly given: number;
            };
        };
    };
    readonly " $refType": "SecurityProgrammes_manager";
};
export type SecurityProgrammes_manager$data = SecurityProgrammes_manager;
export type SecurityProgrammes_manager$key = {
    readonly " $data"?: SecurityProgrammes_manager$data;
    readonly " $fragmentRefs": FragmentRefs<"SecurityProgrammes_manager">;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "SecurityProgrammes_manager",
    "type": "Manager",
    "metadata": null,
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "page",
            "type": "Page"
        },
        {
            "kind": "RootArgument",
            "name": "filter",
            "type": "SecurityProgrammeFilter"
        }
    ],
    "selections": [
        {
            "kind": "LinkedField",
            "alias": null,
            "name": "company",
            "storageKey": null,
            "args": null,
            "concreteType": "Company",
            "plural": false,
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "securityProgrammes",
                    "storageKey": null,
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "filter",
                            "variableName": "filter"
                        },
                        {
                            "kind": "Variable",
                            "name": "page",
                            "variableName": "page"
                        }
                    ],
                    "concreteType": "SecurityProgrammePage",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "SecurityProgramme",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "uuid",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "name",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "createdAt",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "downloadURL",
                                    "args": null,
                                    "storageKey": null
                                }
                            ]
                        },
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "pageInfo",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "PageInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "total",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "offset",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "limit",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "given",
                                    "args": null,
                                    "storageKey": null
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ]
} as any);
(node as any).hash = 'b65aef955282934e27dbfcda535d1d1a';
export default node;
